import React, { ReactElement } from 'react'

import { Size as ButtonSize } from '../Button'
import { IconButtonProps } from '../IconButton'
import { SkeletonBox } from '../SkeletonBox'

const sizeToDimensions: Record<ButtonSize, number> = {
  sm: 40,
  md: 48,
  lg: 56,
}

export type SkeletonIconButtonProps = Pick<IconButtonProps, 'size'>

export const SkeletonIconButton = ({ size = 'sm' }: SkeletonIconButtonProps): ReactElement => {
  const boxSize = sizeToDimensions[size]

  return <SkeletonBox height={boxSize} width={boxSize} />
}
